import { createSchemaMetricsHooks } from 'domains/insights-portal/schemas/utils/schemaFactories.hooks'
import { insightsSchemaConfigs } from 'domains/insights-portal/schemas/types/schema.types'
import { type InsightsPortalSchema } from 'domains/insights-portal/api'

export const getCurrentAndLastPeriodMetrics = ({ schema, listOfMetricsForSpecificSchema }) => {
  const {
    useCurrentPeriodMetrics: getCurrentPeriodMetricsFromSpecificSchema,
    useLastPeriodMetrics: getLastPeriodMetricsFromSpecificSchema,
  } = createSchemaMetricsHooks(
    schema,
    insightsSchemaConfigs[schema].transformFilterParamsToApiFilterSelections
  )
  const { data: specificMetricData, loading: loadingSpecificMetric } =
    getCurrentPeriodMetricsFromSpecificSchema(listOfMetricsForSpecificSchema)
  const { data: specificMetricLastPeriodData, loading: loadingSpecificMetricLastPeriod } =
    getLastPeriodMetricsFromSpecificSchema(listOfMetricsForSpecificSchema)
  return {
    specificMetricData,
    loadingSpecificMetric,
    specificMetricLastPeriodData,
    loadingSpecificMetricLastPeriod,
  }
}

export const useCurrentAndLastPeriodMetricsForAllSchemas =
  (specificSchemaMetricObjectsGroupedBySchema: {}) => {
    const currentPeriodDataGroupedBySpecificMetricSchema = {}
    const currentPeriodLoadingGroupedBySpecificMetric = []
    const lastPeriodDataGroupedBySpecificMetricSchema = {}
    const lastPeriodLoadingGroupedBySpecificMetric = []

    Object.keys(specificSchemaMetricObjectsGroupedBySchema).forEach(
      (schema: InsightsPortalSchema) => {
        const listOfMetricsForSpecificSchema: string[] = specificSchemaMetricObjectsGroupedBySchema[
          schema
        ].map(({ apiMetric }) => apiMetric)
        const {
          specificMetricData,
          loadingSpecificMetric,
          specificMetricLastPeriodData,
          loadingSpecificMetricLastPeriod,
        } = getCurrentAndLastPeriodMetrics({ schema, listOfMetricsForSpecificSchema })
        currentPeriodDataGroupedBySpecificMetricSchema[schema] = specificMetricData
        currentPeriodLoadingGroupedBySpecificMetric.push(loadingSpecificMetric)
        lastPeriodDataGroupedBySpecificMetricSchema[schema] = specificMetricLastPeriodData
        lastPeriodLoadingGroupedBySpecificMetric.push(loadingSpecificMetricLastPeriod)
      }
    )

    return {
      currentPeriodDataGroupedBySpecificMetricSchema,
      currentPeriodLoadingGroupedBySpecificMetric,
      lastPeriodDataGroupedBySpecificMetricSchema,
      lastPeriodLoadingGroupedBySpecificMetric,
    }
  }
